import { Box, Button, Divider, Menu, MenuItem, Stack } from "@mui/material";
import React from "react";
import SearchFilter from "./SearchFilter";
import TitleIcon from "./TitleIcon";
import TuneIcon from "@mui/icons-material/Tune";
import MenuIcon from "@mui/icons-material/Menu";

function ActionsNav({
  title,
  icon,
  mainData,
  toggleDrawer,
  handleClickOpenOrderBy,
  filteredData,
  openMenuOrderBy,
  handleCloseMenuOrderBy,
  anchorEl,
  handleChangeOrderBy,
  handlerSearchField,
  textOrder,
}) {
  return (
    <>
      <TitleIcon title={title} icon={icon} />

      {/* BOTONES DE ACCIÓN: FILTRAR, ORDENAR POR, BUSCAR */}
      <Stack
        component="header"
        flexDirection={{ xs: "column-reverse", md: "row" }}
        justifyContent="space-between"
        alignItems="end"
        mb={4}
      >
        <Box display="flex" gap={1} alignItems="end" width="100%">
          <Button
            type="button"
            sx={{ border: "1px solid #07192D" }}
            disabled={mainData === true ? true : false}
            onClick={toggleDrawer(true)}
          >
            <TuneIcon />
            Filtrar
          </Button>
          <Button
            type="button"
            sx={{ border: "1px solid #07192D" }}
            onClick={handleClickOpenOrderBy}
            disabled={mainData === true ? true : false}
          >
            <MenuIcon />
            Ordenar por
          </Button>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={openMenuOrderBy}
            onClose={handleCloseMenuOrderBy}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            <MenuItem
              onClick={() => handleChangeOrderBy("relevancia")}
              defaultValue="relevancia"
            >
              Relevancia
            </MenuItem>
            <MenuItem onClick={() => handleChangeOrderBy("menorMayor")}>
              {textOrder.first}
            </MenuItem>
            <MenuItem onClick={() => handleChangeOrderBy("mayorMenor")}>
              {textOrder.second}
            </MenuItem>
          </Menu>
        </Box>
        <SearchFilter
          mainData={mainData}
          handlerSearchField={handlerSearchField}
          filteredData={filteredData}
          text={title === "Inmuebles" ? "Buscar inmueble" : "Buscar proyecto por nombre"}
        />
      </Stack>

      <Box>
        <Divider />
      </Box>
    </>
  );
}

export default ActionsNav;
